export default function createYouTubeContentStyle({ videoHeight }) {
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
